import ProductListSpecificationsModal from '@app/components/common/ProductListSpecificationsModal';
import usePagination from '@app/components/pages/plp/usePagination';
import { useSelector } from 'react-redux';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';

const ProductSpecificationModalContainer = ({
  widgetId,
  orderBy,
  queryActionParam,
  removeCurrentModal,
  handleCancelButton,
  title,
  className,
  isModal,
  bucketModelNumberFacet,
  setExpanded: productCardExpanded,
  detailsStatus,
  showSpecificationsToggle,
  appliedFacets,
  showLeftNav,
  productsArrayLength,
  fbeEnabled,
  setAppliedFacets
}) => {
  const { hash, search } = useLocation();
  const { url } = useRouteMatch();
  const history = useHistory();
  const queryParamsObject = { history, url, hash, search };

  const {
    activeFacets,
    batchPartNumbers,
    unitOfMeasure,
    facets,
    filterByEquipment,
    partNumbers
  } = useSelector(state => state.marketingLandingPageUI[widgetId]);

  const { setUrlToPageOneWithFilter } = usePagination();
  return (
    <ProductListSpecificationsModal
      widgetId={widgetId}
      handleCancelButton={handleCancelButton}
      title={title}
      removeCurrentModal={removeCurrentModal}
      setExpanded={productCardExpanded}
      orderBy={orderBy}
      productsArrayLength={productsArrayLength}
      queryActionParam={queryActionParam}
      activeFacets={activeFacets}
      unitOfMeasure={unitOfMeasure}
      showSpecificationsToggle={showSpecificationsToggle}
      detailsStatus={detailsStatus}
      appliedFacets={appliedFacets}
      setAppliedFacets={setAppliedFacets}
      showLeftNav={showLeftNav}
      batchPartNumbers={batchPartNumbers}
      facets={facets}
      bucketModelNumberFacet={bucketModelNumberFacet}
      isModal={isModal}
      className={className}
      setUrlToPageOneWithFilter={setUrlToPageOneWithFilter}
      filterByEquipment={filterByEquipment}
      fbeEnabled={fbeEnabled}
      partNumbers={partNumbers}
      queryParamsObject={queryParamsObject}
      showTotalResultsCount
    />
  );
};

export default ProductSpecificationModalContainer;
